let cachedNonce: string | null | undefined;
let dynamicElementsPatched = false;

export function getCspNonce(): string | null {
  if (cachedNonce !== undefined) {
    return cachedNonce;
  }
  if (typeof document === 'undefined') {
    cachedNonce = null;
    return null;
  }
  const host = document.querySelector('app-root');
  cachedNonce = host?.getAttribute('ngcspnonce') || host?.getAttribute('ngCspNonce') || null;
  return cachedNonce;
}

export function applyCspNonce(element: { setAttribute: (name: string, value: string) => void; nonce?: string }): void {
  const nonce = getCspNonce();
  if (!nonce || !element) {
    return;
  }
  try {
    element.nonce = nonce;
  } catch {
    // Some environments expose nonce as a read-only IDL property.
  }
  element.setAttribute('nonce', nonce);
}

/**
 * Third-party libraries (JSONEditor) inject <style> / <script> tags without a nonce.
 * With style-src nonce, those tags are blocked and sheet.cssRules is undefined.
 */
export function installCspNonceForDynamicElements(): void {
  if (dynamicElementsPatched || typeof document === 'undefined' || !getCspNonce()) {
    return;
  }
  dynamicElementsPatched = true;

  const originalCreateElement = document.createElement.bind(document);
  document.createElement = function <K extends keyof HTMLElementTagNameMap>(
    tagName: K | string,
    options?: ElementCreationOptions
  ) {
    const element = originalCreateElement(tagName as K, options);
    const tag = String(tagName).toLowerCase();
    if (tag === 'style' || tag === 'script') {
      applyCspNonce(element);
    }
    return element;
  } as typeof document.createElement;
}
